// SPDX-FileCopyrightText: Copyright 2026 E-Chat
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial

/** Display only: keep the original identifier for requests and permissions. */
export const shortIdentifier = (value: string): string =>
  value.replace(/^([@#!][^:]+):.+$/, "$1");

/** Format visible error text without changing the error or its diagnostic data. */
export const errorDisplayText = (
  value: string,
  serverName?: string | null,
): string => {
  const text = value
    .replaceAll(/([@#!][\w.=/+-]+):[\w.:[\]-]+/g, "$1")
    .replaceAll(/https?:\/\/[^\s<>"'，。；）)\]}]+/gi, "E-Chat");
  if (!serverName) return text;
  const escapedName = serverName.replaceAll(
    /[.*+?^${}()|[\]\\]/g,
    String.raw`\$&`,
  );
  return text.replaceAll(
    new RegExp(`(?<![\\w@.-])${escapedName}(?![\\w-]|\\.[\\w-])`, "g"),
    "E-Chat",
  );
};
